import BigNumber from "bignumber.js"
import { RestResource } from "./common"
import { SchemaDeSer, SchemaDeSerBuilder } from "./deser"
import {
  DIGITAL_ASSET_CLEARING_ADDRESS_DESER,
  DigitalAssetClearingAddress,
} from "./digital-asset-clearing-address"
import {
  DIGITAL_ASSET_CUSTOMER_ADDRESS_DESER,
  DigitalAssetCustomerAddress,
} from "./digital-asset-customer-address"

export enum DIGITAL_ASSET_FUND_CONVERSION_STATUSES {
  NEEDS_MANUAL_RETURN = "Needs Manual Return",
  PENDING = `Pending`,
  POSTED = `Posted`,
  REJECTED = `Rejected`,
  RETURNED = "Returned",
  SETTLED = "Settled",
  SUBMITTED = "Submitted",
  UNDER_REVIEW = "Under Review",
}

export class DigitalAssetFundConversion extends RestResource {
  asset = ""
  currency = ""
  clearingFeeNotional = ""
  createdAt?: Date
  direction = ""
  notionalValue = ""
  onChainTransactionHash = ""
  quantity = new BigNumber(0)
  status = DIGITAL_ASSET_FUND_CONVERSION_STATUSES.UNDER_REVIEW
  networkFeeNotional? = ""
  networkFeeQuantity? = ""

  digitalAssetCustomerAddress = new DigitalAssetCustomerAddress()
  digitalAssetClearingAddress = new DigitalAssetClearingAddress()
}

export const DIGITAL_ASSET_FUND_CONVERSION_DESER: SchemaDeSer<DigitalAssetFundConversion> =
  new SchemaDeSerBuilder(DigitalAssetFundConversion)
    .ofString("asset")
    .ofString("currency")
    .ofString("clearingFeeNotional")
    .ofDateTime("createdAt")
    .ofString("direction")
    .ofString("notionalValue")
    .ofString("onChainTransactionHash")
    .ofBigNumber("quantity")
    .ofString("status")
    .ofString("networkFeeNotional")
    .ofString("networkFeeNotional")
    .ofNested(
      "digitalAssetCustomerAddress",
      DIGITAL_ASSET_CUSTOMER_ADDRESS_DESER,
      DigitalAssetCustomerAddress
    )
    .ofNested(
      "digitalAssetClearingAddress",
      DIGITAL_ASSET_CLEARING_ADDRESS_DESER,
      DigitalAssetClearingAddress
    )
    .ofInt("id")
    .toDeSer()
